import React, { FunctionComponent } from 'react'

export type Props = {
  width?: number
  fill?: string
}
export type Functions = {}

export type AllProps = Props & Functions

export const MobillyIcon: FunctionComponent<AllProps> = ({ width, fill }) => (
  <svg width={`${width || 37}px`} viewBox="0 0 123.86 151.75">
    <g fill={fill || '#ffffff'}>
      <path d="M61.93,73.69c-21.56,0-39.03,17.48-39.03,39.03s17.47,39.03,39.03,39.03,39.04-17.47,39.04-39.03-17.47-39.03-39.04-39.03ZM82.93,133.38h-7.01v-27.6l-12.6,20.13h-2.83l-12.6-20.13v27.6h-6.95v-40.15h6.95l14.02,22.17,14.02-22.17h7.01v40.15Z" />
      <g>
        <path d="M61.93,0C39.22.07,18.02,6.59,0,17.78l4.84,7.65C21.46,15.13,41,9.13,61.93,9.06c20.93.07,40.47,6.08,57.08,16.37l4.84-7.65C105.84,6.59,84.64.07,61.93,0Z" />
        <path d="M25.81,58.57l4.84,7.65c9.15-5.55,19.83-8.82,31.28-8.89,11.44.07,22.13,3.34,31.28,8.89l4.84-7.65c-10.55-6.44-22.89-10.23-36.12-10.3-13.22.07-25.57,3.86-36.12,10.3Z" />
        <path d="M12.85,38.09l4.84,7.65c12.9-7.94,28.03-12.56,44.24-12.63,16.21.07,31.34,4.69,44.24,12.63l4.84-7.65c-14.3-8.82-31.09-13.97-49.08-14.04-17.98.07-34.78,5.22-49.08,14.04Z" />
      </g>
    </g>
  </svg>
)
